// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import { LOADING } from "../../store/actions";
import instance from "../../store/axios";
import { RedemptionListApiResponse } from "../login/types";

class RedemptionsService {
  private dispatch = useDispatch();

  public async getRedemptionListData(
    status: string[],
    page,
    searchWord,
    sortField,
    sortOrder,
    filters
  ): Promise<
    | {
        data: RedemptionListApiResponse;
        message: string;
      }
    | undefined
  > {
    this.dispatch({ type: LOADING, payload: true });
    let query: string = `?page=${page}&pageSize=20`;

    status.forEach((element: string, index: number) => {
      if (index === 0) {
        query += `&status[${index}]=${element}`;
      } else {
        query += `&status[${index}]=${element}`;
      }
    });

    if (searchWord) {
      query += `&search=${searchWord}`;
    }
    if (sortField) {
      query += `&sortField=${sortField}`;
    }
    if (sortOrder) {
      query += `&sortOrder=${sortOrder === "ascend" ? "asc" : "desc"}`;
    }

    try {
      const response: AxiosResponse<{
        data: RedemptionListApiResponse;
        message: string;
      }> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/redemption${query}`);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", "/redemptions");
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default RedemptionsService;
